<div class="container">
    <div class="header">
        <h2>Add a profile photo</h2>
        <p class="primary-text">Personalize your user account by adding your photo.</p>
    </div>

    <div class="crop-wrapper">
        <pnl-image-cropper #cropper 
            cursor='pointer'
            [zoom]="$zoomValue | async" 
            (fileChanged)="onImageCropperFileChanged($event)" 
            (error)="onImageCropperError($event)">
        </pnl-image-cropper>
        <div class="crop-icon">
            <ds-icon *ngIf="!(canUpload | async)" name="icon-camera" [size]="32"></ds-icon>
        </div>
    </div>

    <div class="fill"></div>

    <div *ngIf="(canUpload | async)">
        <mat-slider #zoomSlider min="1" max="500" style="width: 100%" (input)="onZoomChange($event)" class="zoomSlider"></mat-slider>
        <div (click)="onClearPhotoClicked()" class="skip-step-btn">
            <span class="skip-step-btn-text">Clear photo</span>
        </div>

        <ds-button
            (buttonClick)="onUploadPhotoClicked()"
            [isDisabled]='!(canUpload | async)'
            [isLoading]="isLoading" 
            class="button-submit" 
            [processingText]="'Uploading photo...'" >
            Upload Photo
        </ds-button>
    </div>

    <pnl-error-message [showIcon]="false" [error]="activeError" *ngIf="activeError"></pnl-error-message>

    <div *ngIf="!(canUpload | async)">
        <div (click)="onSkipThisStepClicked()" class="skip-step-btn">
            <span class="skip-step-btn-text">Skip this step</span>
        </div>
    </div>
</div>